import {useParams} from 'react-router-dom';
import {useProjectsByIdQuery} from '../../redux/projects.api';
import {ETemplate} from '../../redux/types';
import FarmXyzPage from './farm-xyz/farm-xyz.page';
import InvestFormPage from './invest-form.page';

import QtFormPage from './quick-token/qt-form.page';

interface IProps {}

const DisplayingFormPage: React.FC<IProps> = () => {
  const {projectId} = useParams<{projectId: string}>();
  const {data: projectData} = useProjectsByIdQuery(projectId);
  function templateType() {
    switch (projectData?.template) {
      case ETemplate.QUICKTOKEN:
        return <QtFormPage />;
      case ETemplate.DEFAULT:
        return <InvestFormPage />;
      case ETemplate.DELLCOIN:
        return <InvestFormPage />;
      case ETemplate.FARM_XYZ:
        return <FarmXyzPage />;
      default:
        return <InvestFormPage />;
    }
  }
  if (!projectData) return null;

  return <div>{templateType()}</div>;
};

export default DisplayingFormPage;
